// Hints one page leaves for the next when it sends you there:
// scrollToImport: the Budget toolbar's Import button (Project settings opens at the import card);
// subBudgetFor: Break down on a line; subBudgetId: Quote to budget's link to the sub-budget a quote went into;
// changeOrder: Approvals & POs' "Prepare a change order" (Generate PDF opens at the change order)
export const pageHints = { scrollToImport: false, subBudgetFor: null, subBudgetId: null, changeOrder: false };
